export default {
  'label/sharing': 'Compartilhando...',
  'label/shared_ok': 'Pronto.',
  'label/close': 'Fechar',
  'label/view': 'Visualizar',
};
